<template>
	<page-container :page="page">
		<section id="intro" class="main-content">
			<div class="row">
				<div class="columns column12">
					<h1>{{ page.title || page.header }}</h1>
					<recursive-sitemap class="sitemap" :items="sitemap" />
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: sitemap } = await useWebsiteFetch('sitemap', {
	query: { language: locale.value },
	key: `${locale.value}/sitemap`,
});
</script>
